const getConfig = (prefix: string) => ({
  [`${prefix}.Records.Last4DensityAverage`]: { format: { nearest: 1 } },
  [`${prefix}.Records.Last4MoistureAverage`]: { format: { nearest: 1 } },
  [`${prefix}.Records.Last4Density2Average`]: { format: { nearest: 1 } },
  [`${prefix}.Records.DensityCount`]: { format: { nearest: 1 } },
  [`${prefix}.Records.MoistureCount`]: { format: { nearest: 1 } },
  [`${prefix}.Records.DensityCount2`]: { format: { nearest: 1 } },
});

export { getConfig };

export default {
  30011: getConfig('data'),
};
